import { axios } from '@/utils/request'
const api = {
  menuItem_qy: '/erp/website/menu_qy.json',
  tree_meta_qy: '/erp/website/tree_meta_qy.json',
  recruitJob_qy: '/erp/resource/recruitJob_qy.json',
  organ_qy: '/erp/website/organ_qy.json',
  organ_opt: '/erp/website/organ_opt.json',
  student_qy: '/erp/website/student_qy.json',
  student_opt: '/erp/website/student_opt.json',
  login: '/login.json',
  resourceQy: '/erp/resource/resourceQy.json',
  videoResourceQy: '/erp/resource/videoResourceQy.json',
  resourceOpt: '/erp/resource/resourceOpt.json',
  resourceQy2: '/erp/resource/resourceQy.json',
  CarouselPictureQy: '/erp/website/CarouselPictureQy.json',
  noticeQy: '/erp/website/pageQy.json',
  resource_qy: '/erp/resource/resource_qy.json',
  topic_qy: '/erp/website/topic_qy.json',
  demand_qy: '/erp/website/demand_qy.json',
  recruit_qy: '/erp/resource/recruitJob_qy.json',
  friendlyLink_qy: '/erp/website/friendlyLink_qy.json',
  user_opt: '/erp/website/user_opt.json',
  survey_qy: '/erp/website/survey_qy.json'
}
export default api
export function survey_qy(parameter) {
  return axios({
    url: api.survey_qy,
    method: 'get',
    params: parameter
  })
}
export function user_opt(parameter) {
  return axios({
    url: api.user_opt,
    method: 'get',
    params: parameter
  })
}
export function organ_opt(parameter) {
  return axios({
    url: api.organ_opt,
    method: 'post',
    data: parameter
  })
}
export function friendlyLink_qy(parameter) {
  return axios({
    url: api.friendlyLink_qy,
    method: 'get',
    params: parameter
  })
}
export function recruit_qy(parameter) {
  return axios({
    url: api.recruit_qy,
    method: 'get',
    params: parameter
  })
}
export function demand_qy(parameter) {
  return axios({
    url: api.demand_qy,
    method: 'get',
    params: parameter
  })
}
export function topic_qy(parameter) {
  return axios({
    url: api.topic_qy,
    method: 'get',
    params: parameter
  })
}
export function resource_qy(parameter) {
  return axios({
    url: api.resource_qy,
    method: 'get',
    params: parameter
  })
}
export function noticeQy(parameter) {
  return axios({
    url: api.noticeQy,
    method: 'get',
    params: parameter
  })
}
export function CarouselPictureQy(parameter) {
  return axios({
    url: api.CarouselPictureQy,
    method: 'get',
    params: parameter
  })
}
export function resourceOpt(parameter) {
  return axios({
    url: api.resourceOpt,
    method: 'get',
    params: parameter
  })
}
export function resourceQy2(parameter) {
  return axios({
    url: api.resourceQy2,
    method: 'get',
    params: parameter
  })
}
export function videoResourceQy(parameter) {
  return axios({
    url: api.videoResourceQy,
    method: 'get',
    params: parameter
  })
}
export function resourceQy(parameter) {
  return axios({
    url: api.resourceQy,
    method: 'get',
    params: parameter
  })
}
export function login(parameter) {
  return axios({
    url: api.login,
    method: 'get',
    params: parameter
  })
}
export function menuItem_qy(parameter) {
  return axios({
    url: api.menuItem_qy,
    method: 'get',
    params: parameter
  })
}
export function tree_meta_qy(parameter) {
  return axios({
    url: api.tree_meta_qy,
    method: 'get',
    params: parameter
  })
}
export function recruitJob_qy(parameter) {
  return axios({
    url: api.recruitJob_qy,
    method: 'get',
    params: parameter
  })
}
export function organ_qy(parameter) {
  return axios({
    url: api.organ_qy,
    method: 'get',
    params: parameter
  })
}
export function student_qy(parameter) {
  return axios({
    url: api.student_qy,
    method: 'get',
    params: parameter
  })
}
export function student_opt(parameter) {
  return axios({
    url: api.student_opt,
    method: 'get',
    params: parameter
  })
}
export function autoApi(url, parameter) {
  return axios({
    url: url,
    method: 'get',
    params: parameter
  })
}